import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  error: {
    color: '#ef5350',
    marginRight: '5px',
    marginTop: -3,
  },
  success: {
    color: '#43a047',
    marginRight: '5px',
    marginTop: -3,
  },
  info: {
    color: theme.palette.primary.main,
    marginTop: -3,
    marginRight: '5px',
  },
}));